import {IntercomDiagramTypes} from '@q9elements/ui-kit/common';

export enum MAPS_TYPES_ENUM {
  ARCHITECTURE = 'architecture',
  UPN = 'upn',
  AGENT_INSTRUCTION = 'agentInstruction',
  AGENT_INTERACTION = 'agentInteraction',
  INTERACTION_FLOW = 'interactionFlow',
  CAPABILITY = 'capability',
  DATA_MODEL = 'dataModel',
  CUSTOMER_JOURNEY = 'customerJourney',
  SYSTEM_ARCHITECTURE = 'systemArchitecture',
  WHITEBOARD = 'whiteboard'
}

export const drilldownActions = {
  [MAPS_TYPES_ENUM.UPN]: 'upnDrilldown',
  [MAPS_TYPES_ENUM.AGENT_INSTRUCTION]: 'agentInstructionDrilldown',
  [MAPS_TYPES_ENUM.AGENT_INTERACTION]: 'agentInteractionDrilldown',
  [MAPS_TYPES_ENUM.INTERACTION_FLOW]: 'interactionFlowDrilldown',
  [MAPS_TYPES_ENUM.CAPABILITY]: 'capabilityDrilldown',
  [MAPS_TYPES_ENUM.DATA_MODEL]: 'dataModelDrilldown',
  [MAPS_TYPES_ENUM.CUSTOMER_JOURNEY]: 'customerJourneyDrilldown',
  [MAPS_TYPES_ENUM.SYSTEM_ARCHITECTURE]: 'systemArchitectureDrilldown'
} as const;

export const typeToEventDisplay = {
  [MAPS_TYPES_ENUM.UPN]: IntercomDiagramTypes.UPN,
  [MAPS_TYPES_ENUM.CUSTOMER_JOURNEY]: IntercomDiagramTypes.CUSTOMER_JOURNEY,
  [MAPS_TYPES_ENUM.SYSTEM_ARCHITECTURE]: IntercomDiagramTypes.SYSTEM_ARCHITECTURE,
  [MAPS_TYPES_ENUM.DATA_MODEL]: IntercomDiagramTypes.DATA_MODEL,
  [MAPS_TYPES_ENUM.INTERACTION_FLOW]: IntercomDiagramTypes.INTERACTION_FLOW,
  [MAPS_TYPES_ENUM.CAPABILITY]: IntercomDiagramTypes.CAPABILITY,
  [MAPS_TYPES_ENUM.AGENT_INSTRUCTION]: IntercomDiagramTypes.AGENT_INSTRUCTION,
  [MAPS_TYPES_ENUM.AGENT_INTERACTION]: IntercomDiagramTypes.AGENT_INTERACTION,
  [MAPS_TYPES_ENUM.WHITEBOARD]: IntercomDiagramTypes.WHITEBOARD,
  [MAPS_TYPES_ENUM.ARCHITECTURE]: IntercomDiagramTypes.ARCHITECTURE
};

type ActionType = (typeof drilldownActions)[keyof typeof drilldownActions];

export type DrilldownConfig = {
  actionType: ActionType;
  drilldownSubtype: MAPS_TYPES_ENUM;
  q9Track: string;
};

export const drilldownConfigs: readonly DrilldownConfig[] = [
  {
    actionType: drilldownActions.upn,
    drilldownSubtype: MAPS_TYPES_ENUM.UPN,
    q9Track: 'CONTEXT_MENU.ACTIVITY.DRILLDOWN.NEW_UPN_DRILLDOWN'
  },
  {
    actionType: drilldownActions.agentInstruction,
    drilldownSubtype: MAPS_TYPES_ENUM.AGENT_INSTRUCTION,
    q9Track: 'CONTEXT_MENU.ACTIVITY.DRILLDOWN.NEW_AGENT_INSTRUCTION_DRILLDOWN'
  },
  {
    actionType: drilldownActions.agentInteraction,
    drilldownSubtype: MAPS_TYPES_ENUM.AGENT_INTERACTION,
    q9Track: 'CONTEXT_MENU.ACTIVITY.DRILLDOWN.NEW_AGENT_INTERACTION_DRILLDOWN'
  },
  {
    actionType: drilldownActions.interactionFlow,
    drilldownSubtype: MAPS_TYPES_ENUM.INTERACTION_FLOW,
    q9Track: 'CONTEXT_MENU.ACTIVITY.DRILLDOWN.NEW_INTERACTION_FLOW_DRILLDOWN'
  },
  {
    actionType: drilldownActions.capability,
    drilldownSubtype: MAPS_TYPES_ENUM.CAPABILITY,
    q9Track: 'CONTEXT_MENU.ACTIVITY.DRILLDOWN.NEW_CAPABILITY_DRILLDOWN'
  },
  {
    actionType: drilldownActions.dataModel,
    drilldownSubtype: MAPS_TYPES_ENUM.DATA_MODEL,
    q9Track: 'CONTEXT_MENU.ACTIVITY.DRILLDOWN.NEW_DATA_MODEL_DRILLDOWN'
  },
  {
    actionType: drilldownActions.customerJourney,
    drilldownSubtype: MAPS_TYPES_ENUM.CUSTOMER_JOURNEY,
    q9Track: 'CONTEXT_MENU.ACTIVITY.DRILLDOWN.NEW_CUSTOMER_JOURNEY_DRILLDOWN'
  },
  {
    actionType: drilldownActions.systemArchitecture,
    drilldownSubtype: MAPS_TYPES_ENUM.SYSTEM_ARCHITECTURE,
    q9Track: 'CONTEXT_MENU.ACTIVITY.DRILLDOWN.NEW_SYSTEM_ARCHITECTURE_DRILLDOWN'
  }
] as const;
